export function hideFromWappalyzer() {
  const wnd = window as any;

  wnd._ = null;
  wnd.Hammer.VERSION = '';
  document.getElementsByTagName('app-root')[0].setAttribute('ng-version', '');
}
